export const headersTableConfig = [{
    title: '',
    dataSource: 'avatar',
    width: '*'
},{
    title: 'USER NAME',
    dataSource: 'UserName',
    sortable: true,
    width: '20%'
},{
    title: 'NAME',
    dataSource: 'Name',
    sortable: true,
    width: '30%'
},{
    title: 'EMAIL',
    dataSource: 'Email',
    sortable: true,
    width: '30%'
},{
    title: 'OPTIONS',
    dataSource: 'Active',
    width: '*'
}]